import { Link, useLocation } from 'react-router';
import { useAppSelector } from '@/app/hooks';
import { initials } from '@/shared/lib';
import { selectCurrentUser } from '@/shared/session';

/** Signed-in user in the top-right corner of the main area; opens the profile. */
export function UserChip() {
  const { pathname } = useLocation();
  const user = useAppSelector(selectCurrentUser);

  return (
    <Link
      className="user-chip"
      to="/profile"
      aria-current={pathname.split('/')[1] === 'profile' ? 'page' : undefined}
    >
      <span className="avatar" aria-hidden="true">
        {initials(user?.displayName ?? '')}
      </span>
      <span className="user-chip__text">
        <span>{user?.displayName}</span>
        <small>{user?.email}</small>
      </span>
    </Link>
  );
}
